/** The boxes' shared look: raised, dashed until filled, green and ringed in focus. */
export function pasteBoxClass(filled: boolean, height: string): string {
    const edge = filled ? "border-solid border-line-strong" : "border-dashed border-line-control";
    return `box-border block w-full resize-none rounded-card border-[1.5px] bg-card-raised p-4 text-[13px] leading-normal text-fg outline-none placeholder:text-fg-faint focus:border-green focus:shadow-[0_0_0_3px_var(--color-tint-green)] ${edge} ${height}`;
}
